import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    poolName: 'Pool name',
    status: 'Status',
    tvl: 'TVL',
    commission: 'Commission',
    apy: 'APY',
    myPosition: 'My position',
    actions: 'Actions',
    delegatorsValue:
      '{value} {value, plural, =1 {delegator} other {delegators}}',
  },
};
